'use strict';
export default function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}